import { Sprite } from 'pixi.js';

export class TileBurst extends Sprite {
    constructor(size: [number, number]) {
        super();

        const assets = PIXI.utils.TextureCache;
        const frames = [
            assets['fx/match0001'],
            assets['fx/match0002'],
            assets['fx/match0003'],
            assets['fx/match0004'],
            assets['fx/match0005'],
            assets['fx/match0006'],
            assets['fx/match0007'],
            assets['fx/match0008'],
            assets['fx/match0009'],
            assets['fx/match0010'],
            assets['fx/match0011'],
            assets['fx/match0012'],
            assets['fx/match0013'],
        ];

        const anim = new PIXI.extras.AnimatedSprite(frames);
        anim.anchor.set(0.5);
        anim.animationSpeed = 0.5;
        anim.loop = false;

        const tileBg = new Sprite(PIXI.utils.TextureCache['tile-bg']);
        anim.scale.set(size[0] / tileBg.width);
        this.addChild(anim);
        anim.play();

        anim.onComplete = () => {
            anim.destroy();
            this.destroy();
        };
    }
}
